import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, inject, input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { TranslateModule } from '@ngx-translate/core';
import { applyFilterNavigationHandler } from 'dias-core/utils/category/filter-navigation-utils';
import { Observable } from 'rxjs';

import { ShoppingFacade } from 'ish-core/facades/shopping.facade';
import { Facet } from 'ish-core/models/facet/facet.model';
import { FilterNavigation } from 'ish-core/models/filter-navigation/filter-navigation.model';
import { Filter } from 'ish-core/models/filter/filter.model';
import { URLFormParams } from 'ish-core/utils/url-form-params';

@Component({
  selector: 'custom-now-shopping-navigation',
  templateUrl: './now-shopping-navigation.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FaIconComponent, AsyncPipe, TranslateModule],
})
export class NowShoppingNavigationComponent implements OnInit {
  private shoppingFacade = inject(ShoppingFacade);
  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);

  readonly fragmentOnRouting = input<string>(undefined);
  filter$: Observable<FilterNavigation>;

  ngOnInit(): void {
    this.filter$ = this.shoppingFacade.currentFilter$(true);
  }

  getActiveFilters(filterNavigation: FilterNavigation): Filter[] {
    const filters: Filter[] = [];

    filterNavigation?.filter?.forEach(filter => {
      let facets: Facet[] = [];
      facets = filter.facets.filter(
        (facet, index, self) => index === self.findIndex(t => t?.displayName === facet?.displayName) && facet.selected
      );
      if (facets.length) {
        const filterElement = {
          displayType: filter.displayType,
          facets,
          id: filter.id,
          limitCount: filter.limitCount,
          name: filter.name,
          selectionType: filter.selectionType,
        };
        filters.push(filterElement);
      }
    });
    return filters;
  }

  applyFilter(event: { searchParameter: URLFormParams }) {
    applyFilterNavigationHandler(event, this.router, this.activatedRoute);
  }
}
